import { TaskFetchStatus } from '~/modules/tasks/taskModels.ts';
import type { TTasksRequestState, TTasksState } from './types.ts';

export const makeTasksRequestState = <T>(data: T): TTasksRequestState<T> => ({
  data,
  status: TaskFetchStatus.Idle,
  error: null,
});

export const initialState: TTasksState = {
  administrationRoles: makeTasksRequestState([]),
  administrationTasks: makeTasksRequestState({
    tasks: [],
    page: 0,
    size: 5,
    totalElements: 0,
  }),
  uakdoAccess: makeTasksRequestState({
    hasResponsibleAccess: false,
    hasControllerAccess: false,
  }),
  taskSupervisors: makeTasksRequestState(null),
  patchAssignee: makeTasksRequestState(null),
  updateStatus: makeTasksRequestState(null),
};
